import { USER_APPROVE_STATUS, USER_QUALIFY_STATUS } from '@/config/constants';
import type { User } from '@/types/UserType';

export function shouldShowUserLoanStatusChips(user?: User | null): boolean {
  if (!user) return false;
  const isUserApproved =
    user.approveStatus === USER_APPROVE_STATUS.APPROVED &&
    Boolean(user.approvalAmount);
  const isUserQualified = user.qualifyStatus === USER_QUALIFY_STATUS.QUALIFY;
  return isUserApproved || isUserQualified;
}
